<div class="audit-logs-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="audit-logs-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="audit-logs-shell__sidebar"
    [class.audit-logs-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.audit-logs-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="audit-logs-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="audit-logs-page">
      <section class="audit-logs-page__panel app-card">
        <div class="audit-logs-page__panel-header">
          <div class="audit-logs-page__heading-copy">
            <h2 class="app-title-serif">Audit Logs</h2>
          </div>

          <div class="audit-logs-page__actions">
            <button type="button" class="app-button app-button--secondary audit-logs-page__action-button" [disabled]="isLoading || isExporting" (click)="handleExportAuditLogs()">
              {{ isExporting ? 'Exporting...' : 'Export CSV' }}
            </button>
          </div>
        </div>

        <div class="audit-logs-page__panel-body">
          <form class="audit-logs-filters" [formGroup]="filterForm">
            <label class="app-form-field audit-logs-filters__field audit-logs-filters__field--search">
              <span class="app-form-label">Search</span>
              <div class="audit-logs-filters__search">
                <span class="audit-logs-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="app-form-input audit-logs-filters__search-input" type="text" placeholder="Search" formControlName="search" />
              </div>
            </label>

            <label class="app-form-field audit-logs-filters__field">
              <span class="app-form-label">Module Name</span>
              <input class="app-form-input" type="text" placeholder="Module name" formControlName="module_name" />
            </label>

            <label class="app-form-field audit-logs-filters__field">
              <span class="app-form-label">Event</span>
              <select class="app-form-select" formControlName="event">
                @for (option of eventOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>

            <label class="app-form-field audit-logs-filters__field">
              <span class="app-form-label">From Date</span>
              <input class="app-form-input" type="date" formControlName="from_date" />
            </label>

            <label class="app-form-field audit-logs-filters__field">
              <span class="app-form-label">To Date</span>
              <input class="app-form-input" type="date" formControlName="to_date" />
            </label>

            <div class="app-filter-actions audit-logs-filters__actions">
              <button
                type="button"
                class="app-button app-button--secondary app-filter-actions__button audit-logs-filters__clear-button"
                [disabled]="isLoading || isExporting"
                (click)="resetFilters()"
              >
                Clear
              </button>
            </div>
          </form>

          <div class="audit-logs-page__table-wrap app-table-scroll">
            <table class="audit-logs-table">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>User</th>
                  <th>Module</th>
                  <th>Subject Type</th>
                  <th>Event</th>
                  <th>Description</th>
                  <th>Performed On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td colspan="8" class="audit-logs-page__empty-state">Loading audit logs...</td>
                  </tr>
                } @else if (filteredLogs.length) {
                  @for (item of filteredLogs; track trackByLogId($index, item)) {
                    <tr>
                      <td>{{ $index + 1 + ((pagination.page_no - 1) * pagination.page_size) }}</td>
                      <td>{{ formatText(item.user_name) }}</td>
                      <td>{{ formatModuleName(item.module_name) }}</td>
                      <td>{{ formatText(item.subject_type) }}</td>
                      <td>{{ getEventLabel(item.event) }}</td>
                      <td class="audit-logs-table__description">
                        @if (isEditEvent(item.event)) {
                          <button
                            type="button"
                            class="audit-logs-table__description-link"
                            [attr.title]="formatDescription(item)"
                            [disabled]="isDetailLoading && selectedLogItem?.id === item.id"
                            (click)="openAuditLogDetail(item)"
                          >
                            {{ formatDescription(item) }}
                          </button>
                        } @else {
                          <span class="audit-logs-table__description-text" [attr.title]="formatDescription(item)">{{ formatDescription(item) }}</span>
                        }
                      </td>
                      <td class="audit-logs-table__performed-on">{{ formatText(item.performed_on) }}</td>
                      <td>
                        <button
                          type="button"
                          class="audit-logs-table__download-icon-button"
                          [disabled]="downloadingLogId === item.id"
                          [title]="'Download Full Log'"
                          aria-label="Download full log"
                          (click)="downloadFullLog(item)"
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3v12"></path>
                            <path d="m7 10 5 5 5-5"></path>
                            <path d="M5 21h14"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td colspan="8" class="audit-logs-page__empty-state">No audit logs found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="audit-logs-page__pagination">
              <div class="audit-logs-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="audit-logs-page__pagination-actions">
                <button type="button" class="app-button app-button--secondary audit-logs-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                  Previous
                </button>

                <div class="audit-logs-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="audit-logs-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button type="button" class="audit-logs-page__pagination-page" [class.audit-logs-page__pagination-page--active]="pagination.page_no === page" [disabled]="isLoading" (click)="goToPage(page)">{{ page }}</button>
                    }
                  }
                </div>

                <button type="button" class="app-button app-button--secondary audit-logs-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                  Next
                </button>
              </div>

              <label class="audit-logs-page__pagination-size">
                <span class="audit-logs-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select audit-logs-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>
</div>

@if (isDetailModalOpen) {
  <div class="app-modal-backdrop">
    <dialog class="app-modal audit-log-detail-modal" open>
      <div class="audit-log-detail-modal__header">
        <div class="audit-log-detail-modal__header-copy">
          <h3>{{ getDetailTitle() }}</h3>
          <p>{{ getDetailSubtitle() }}</p>
        </div>

        <button type="button" class="app-button app-button--icon audit-log-detail-modal__close" aria-label="Close modal" (click)="closeAuditLogDetailModal()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="audit-log-detail-modal__body">
        @if (isDetailLoading) {
          <div class="audit-log-detail-modal__empty">Loading changes...</div>
        } @else if (selectedLogChanges.length) {
          <div class="audit-log-detail-modal__table-wrap app-table-scroll">
            <table class="audit-log-detail-modal__table">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Previous Value</th>
                  <th>New Value</th>
                </tr>
              </thead>
              <tbody>
                @for (change of selectedLogChanges; track trackByChangeKey($index, change)) {
                  <tr>
                    <td>{{ change.key }}</td>
                    <td><span class="audit-log-detail-modal__cell-value">{{ formatDiffValue(change.old_value) }}</span></td>
                    <td><span class="audit-log-detail-modal__cell-value audit-log-detail-modal__cell-value--new">{{ formatDiffValue(change.new_value) }}</span></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="audit-log-detail-modal__empty">
            {{ detailModalErrorMessage || 'No changes found.' }}
          </div>
        }
      </div>

      <div class="audit-log-detail-modal__footer">
        <button type="button" class="app-button app-button--secondary" (click)="closeAuditLogDetailModal()">Close</button>
      </div>
    </dialog>
  </div>
}
